import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const RightChevron: FC<SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon viewBox={`0 0 24 40`} {...props}>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g transform='translate(-1051.638935, -540.000000)' fill='currentColor'>
					<g transform='translate(169.000000, 460.000000)'>
						<g transform='translate(892.500000, 104.000000) scale(-1, 1) translate(-892.500000, -104.000000) translate(863.000000, 50.000000)'>
							<polygon
								transform='translate(27.680532, 50.000000) scale(-1, 1) translate(-27.680532, -50.000000) '
								points='19.3610649 70 16 66.6389351 32.6389351 50 16 33.3610649 19.3610649 30 39.3610649 50'
							/>
						</g>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
